// Wave 10.1 / 10.11 / 10C / 16 (Vania 2 Oct) — fire-and-forget event logger.
// Writes to /api/track/*. Never blocks the user tap. Guest taps are counted too.
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export function trackTicketClick({ eventId, organiserHandle = "", source = "card" }) {
  try {
    axios.post(
      `${API}/api/track/ticket_click`,
      {
        event_id: eventId,
        organiser_handle: organiserHandle || "",
        source,
      },
      { withCredentials: true, timeout: 4000 }
    ).catch(() => {});
  } catch { /* never block */ }
}

/** Generic frontend event logger — pageview, search, going_tap, interested_tap,
 *  save_tap, like_tap, share_tap, review_posted. Server-side kinds
 *  (signin_success, account_created) are logged by their backend router. */
export function trackEvent(kind, payload = {}) {
  try {
    axios.post(
      `${API}/api/track/event`,
      { kind, payload },
      { withCredentials: true, timeout: 4000 }
    ).catch(() => {});
  } catch { /* non-fatal */ }
}

/** Wave 16.2 helpers — one call per tap. Unsaving / unliking / clearing an
 *  intent does NOT count; only the "fire" action is logged. */
export function trackGoing(eventId)      { trackEvent("going_tap",      { event_id: eventId }); }
export function trackInterested(eventId) { trackEvent("interested_tap", { event_id: eventId }); }
export function trackSave(eventId)       { trackEvent("save_tap",       { event_id: eventId }); }
export function trackLike(eventId)       { trackEvent("like_tap",       { event_id: eventId }); }
export function trackReviewPosted(eventId, score) {
  trackEvent("review_posted", { event_id: eventId, member_score: score });
}
export function trackSearch(q, resultCount) {
  const query = ((q || "") + "").trim().toLowerCase();
  if (!query) return;
  trackEvent("search", { q: query, result_count: Math.max(0, resultCount | 0) });
}

/** Wave 16.3 (Vania 2 Oct) — on the FIRST pageview of a session, send
 *  `document.referrer` (external only; our own domains are dropped) plus any
 *  utm_* params on the URL. Subsequent pageviews only send the path. The flag
 *  lives in `sessionStorage` so it resets when the tab closes. */
const OWN_HOST_RX = /(^|\.)(watuwako\.com|watuwako-app\.preview\.emergentagent\.com|watu-backend\.preview\.emergentagent\.com)$/i;

export function trackPageview(path) {
  try {
    const url = new URL(window.location.href);
    const payload = { path: path || url.pathname };
    ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
      const v = url.searchParams.get(k);
      if (v) payload[k] = v;
    });
    let isFirst = false;
    try {
      if (!sessionStorage.getItem("ww_pv_seen")) {
        sessionStorage.setItem("ww_pv_seen", "1");
        isFirst = true;
      }
    } catch { isFirst = true; }
    if (isFirst) {
      const ref = (document.referrer || "").trim();
      let external = "";
      if (ref) {
        try {
          const host = new URL(ref).hostname.toLowerCase();
          if (!OWN_HOST_RX.test(host)) external = ref;
        } catch { /* malformed referrer — ignore */ }
      }
      // Wave 16b.2 (Vania 2 Oct) · always include the field on the first
      // pageview (even when empty) so the admin referrers panel can tell
      // "direct" (field present, value empty) apart from "not tracked
      // (before 2 Oct)" (field absent entirely, pre-16.3 pageviews).
      payload.referrer = external;
    }
    trackEvent("pageview", payload);
  } catch { /* non-fatal */ }
}
